/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { InnerBlocks } from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */

export default function save( props ) {
	const { className, attributes } = props;
	const { hasAccordion, blockClientId } = attributes;
	const wrapperClasses = classnames(
		className,
		`gutenify-block-faq-wrapper`,
		hasAccordion ? 'gutenify-block-faq-accordion' : '',
		`gutenify-section-${ blockClientId }`,
	);
	return <div className={ wrapperClasses }><InnerBlocks.Content /></div>;
}
